import HierarchyDetails from '../../slices/maintenance/hierarchy/HierarchyDetails'
import ScheduledList from '../../slices/maintenance/scheduled/ScheduledList'
import ScheduledDetails from '../../slices/maintenance/scheduled/ScheduledDetails'
import ScheduledLogsList from '../../slices/maintenance/scheduled/ScheduledLogsList'

const maintenanceReducer = {
    hierarchyDetails: HierarchyDetails,
    scheduledList: ScheduledList,
    scheduledDetails: ScheduledDetails,
    scheduledLogsList: ScheduledLogsList,
};

export default maintenanceReducer;